var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSingleQuotesR = function SvgSingleQuotesR(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C13.6569 17 15 15.6569 15 14V12M15 12V8.59846C15 8.0395 15 7.7596 14.8911 7.5459C14.7952 7.35774 14.6419 7.20487 14.4537 7.10899C14.2398 7 13.9602 7 13.4001 7H11.6001C11.04 7 10.7598 7 10.5459 7.10899C10.3577 7.20487 10.2049 7.35774 10.109 7.5459C10 7.75981 10 8.04005 10 8.6001V10.4001C10 10.9602 10 11.2398 10.109 11.4537C10.2049 11.6419 10.3577 11.7952 10.5459 11.8911C10.7596 12 11.0395 12 11.5985 12H15Z",
    stroke: "#282830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSingleQuotesR, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Single_Quotes_R.1fc15df2.svg";
export { ForwardRef as ReactComponent };